<template>
  <v-menu
    offset-y
    rounded="lg"
    content-class="elevation-2"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        class="pa-1"
        v-bind="attrs"
        v-on="on"
      >
        {{ icon }}
      </v-icon>
    </template>
    <slot />
  </v-menu>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    icon: {
      type: String,
      default: 'more_vert',
    },
  },
};
</script>
